module.exports = __webpack_public_path__ + "static/media/DecIdFront.426374ed.tsx";